import React from 'react';
import styled from '@emotion/styled';
import { Flex } from 'reflexbox';
import {
  MARKETING_PAGE_BREAKPOINT_DESKTOP,
  MARKETING_PAGE_BREAKPOINT_TABLET,
} from '../../Style/breakpoints';
import { LeadingInstitutionsProps } from './types';
import { InstitutionLogo } from '../InstitutionLogo/components';

const Container = styled(Flex)`
  background: linear-gradient(
    30.44deg,
    #f8f6f8 36.95%,
    rgba(255, 255, 255, 0) 97.42%
  );
  padding: 12px;
  flex-direction: column;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    margin-top: 60px;
    padding: 60px 0 60px 0;
  }
`;

const Header = styled.div`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 30px;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: #041416;
  padding: 0px;
  text-align: center;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    text-align: center;
    padding: 24px;
    font-weight: 900;
  }
  @media only screen and (max-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    margin-top: 50px;
  }
`;

const Logos = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  maxWidth: 1170,
  width: '100%',
  margin: '0 auto',
});

const Logo = styled(InstitutionLogo)({
  margin: '2%',
  width: '29%',

  [`@media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_TABLET})`]: {
    margin: '2%',
    width: '21%',
  },

  '@media only screen and (min-width: 900px)': {
    margin: '1%',
    width: '18%',
  },

  [`@media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP})`]: {
    margin: '1%',
    width: '14%',
  },
});

export const LeadingInstitutions = React.memo(
  ({ title, logos }: LeadingInstitutionsProps) => {
    return (
      <Container flexDirection="column" p={24}>
        <Header>{title}</Header>
        <Logos>
          {logos.map((logoProps) => (
            <Logo key={logoProps.id} {...logoProps} />
          ))}
        </Logos>
      </Container>
    );
  }
);
